/* eslint-disable class-methods-use-this */
import moment from 'moment';
import Rule from './rule';

export default class ExcludeRule extends Rule {
  /**
   *
   * @param {string} ruleText
   * @param {string} attribute
   * @param {boolean} active
   */
  constructor(ruleText, attribute, active) {
    super(ruleText, attribute, active);
    const num = (x = '') => Number.parseFloat(x.replace(/,/g, '.'));
    const catchCondition = (condition) => {
      try {
        return condition();
      } catch (err) {
        console.error(err);
        return false;
      }
    };
    this.ruleType = 'EXCLUDE';
    this.isDateRule = false;
    this.isEmptyRule = false;
    this.isFilledRule = false;
    this.usesContains = false;
    this.compile(ruleText);
    this.conditions = {
      '==': (a, b) => a === b,
      '!=': (a, b) => a !== b,
      '>=': (a, b) => catchCondition(() => num(a) >= num(b)),
      '<=': (a, b) => catchCondition(() => num(a) <= num(b)),
      '>': (a, b) => catchCondition(() => num(a) > num(b)),
      '<': (a, b) => catchCondition(() => num(a) < num(b)),
      contains: (a, b) => {
        if (a !== undefined) {
          return a.includes(b);
        }
        return false;
      },
      containsMultiple: (a, b) => {
        if (a !== undefined) {
          return b.some(w => a.includes(w));
        }
        return false;
      },
      containsNegative: (a, b) => {
        if (a !== undefined) {
          return !a.includes(b);
        }
        return true;
      },
      containsMultipleNegative: (a, b) => {
        if (a !== undefined) {
          return b.every(w => !a.includes(w));
        }
        return true;
      }
    };
  }

  compileFromDate(text) {
    const splitText = text.replace(/^\s?exclude --date /i, '').split(/to/i).map(x => x.trim());
    this.args = [moment(splitText[0], 'DD-MM-YYYY'), moment(splitText[1], 'DD-MM-YYYY')];
    this.isDateRule = true;
  }

  compileFromText(text) {
    const containsFound = text.includes('--contains');
    const containsMultipleFound = text.includes('--contains-multiple');
    const negativeFound = text.includes('!--');
    const splitText = text.replace(/^\s?exclude( !?--contains(-multiple)?)? /i, '').split(' ');
    const value = splitText.slice(1).join(' ') || null;
    let condition;
    if (containsMultipleFound) {
      condition = negativeFound ? 'containsMultipleNegative' : 'containsMultiple';
      this.args = [condition, value.split('~~')];
    } else {
      if (containsFound) {
        this.usesContains = true;
        condition = negativeFound ? 'containsNegative' : 'contains';
      } else {
        condition = splitText.splice(0, 1)[0].trim();
      }
      this.args = [condition, value];
    }
  }

  runWithDate(input) {
    const fromUnix = this.args[0].unix();
    const toUnix = this.args[1].unix();
    const inputDate = moment(input, 'DD-MM-YYYY');
    if (!inputDate.isValid()) {
      return false;
    }
    const inputUnix = inputDate.unix();

    return inputUnix >= fromUnix && inputUnix <= toUnix;
  }

  runWithText(input, arg) {
    return this.conditions[this.args[0]](input, arg);
  }

  runWithEmpty(input) {
    return !input || input.trim() === '';
  }

  runWithFilled(input) {
    return !!input && input.trim() !== '';
  }

  compile(text) {
    if (/^\s?exclude --date /i.test(text)) {
      this.compileFromDate(text);
    } else if (/^\s?exclude --empty/i.test(text)) {
      this.isEmptyRule = true;
    } else if (/^\s?exclude --filled/i.test(text)) {
      this.isFilledRule = true;
    } else {
      this.compileFromText(text);
    }
  }

  evaluate(input, arg) {
    if (this.isEmptyRule) return this.runWithEmpty(input);
    if (this.isFilledRule) return this.runWithFilled(input);
    if (this.isDateRule) return this.runWithDate(input);
    return this.runWithText(input, arg);
  }

  run(input, headers, resolve) {
    let arg = '';
    if (this.args) {
      arg = headers.includes(this.args[1]) ? resolve(this.args[1]) : this.args[1];
    }
    const exclude = this.evaluate(input, arg);
    return exclude ? null : input;
  }

  validate() {
    if (this.isEmptyRule || this.isFilledRule) return true;
    if (this.isDateRule) return this.args[0].isValid() && this.args[1].isValid();
    return !!this.args && this.args.length === 2 && this.args[1] !== null
      && !!this.conditions[this.args[0]];
  }
}
